<template>
    <div class="stats-page">
        <div class="chart-row">      
            <Chart name="date" />
        </div>
    </div>
</template>

<script>

import Chart from '../components/Chart.vue'

import WebSoc from '../utils/WebSoc.js'

export default {
    components: {
        Chart
    },
    computed: {
        client_id () { return this.$store.state.client_id }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            var db = this.client_id+'-customers'
        }
    }
}

</script>

<style lang="scss">
.stats-page {
    .chart-row {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        > div {
            margin: 10px;
        }

    }
}    
</style>